import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { OracleResponsysDataset } from 'app/model/dataset/oracle-responsys.dataset';
import { Metamodel } from 'app/model/base/model';
import { OracleResponsysLinkedService } from 'app/model/linkedservice/oracle-responsys.linkedservice';
import { format } from 'app/shared/utils/string.util';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';

export const oracleResponsysObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(OracleResponsysDataset).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.OracleResponsys_DisplayText),
    supportLinkedServiceTypes: [Metamodel.modelFor(OracleResponsysLinkedService).name],
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-Oracle'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['ServicesApps']
};
